import ajax from '@/assets/js/interceptor';
export default {
  state: {
    usePermission: {},
    promiseMenu: []
  },
  mutations: {
    ADD_ROUTERS (state, router) {
      state.promiseMenu = router;
    },
    SAVE_USERPERMISSION (state, data) {
      state.usePermission = data;
    }
  },
  getters: {
    roles: state => state.promiseMenu
  },
  actions: {
    GetMenuList ({ commit }) {
      return new Promise((resolve, reject) => {
        const appId = process.env.VUE_APP_HOST_APPID;
        ajax(`/v1/userInfo/appMenus/${appId}`).then(res => {
          const { code, data } = res.data;
          if (code == 200) {
            resolve(data);
          } else {
            reject(new Error('错误'));
          }
        }).catch(error => reject(error));
      });
    },
    getPermisionItem ({ commit }, menuCode) {
      return new Promise(resolve => {
        const data = {
          appId: process.env.VUE_APP_HOST_APPID,
          menuCode
        };
        ajax.post('/v1/userAuth/userGetMenuAuth', data).then(res => {
          const { code, data } = res.data;
          if (code == 200) {
            const { pageComponentMap } = data;
            let pageComponent = null;
            if (Object.prototype.toString.call(pageComponentMap) === '[object Object]') {
              const arr = Object.keys(pageComponentMap);
              if (!arr.length == 0) {
                pageComponent = pageComponentMap;
              }
            }
            resolve({ ...data, pageComponent });
            commit('SAVE_USERPERMISSION', { ...data, pageComponent });
          }
        });
      });
    }
  }
};
